import { motion } from "framer-motion";


function GamesStats({ title, value, icon }) {

  return (

        <motion.div
            whileHover={{ scale: 1.03 }}
            className="bg-slate-900 rounded-3xl border border-slate-800 p-6 shadow-lg"
        >

            <div className="flex justify-between items-center">

                <div>

                    <p className="text-gray-400">
                        {title}
                    </p>


                    <h2 className="text-4xl font-bold mt-3 text-cyan-400">
                        {value}
                    </h2>


                </div>


                <div className="text-5xl">
                    {icon}
                </div>


            </div>


        </motion.div>

    );

};


export default GamesStats;
